import { render, staticRenderFns } from "./banner-item.vue?vue&type=template&id=40c64112&scoped=true&"
import script from "./banner-item.vue?vue&type=script&lang=js&"
export * from "./banner-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c64112",
  null
  
)

export default component.exports